import { render, staticRenderFns } from "./ReducedPriceFormula.vue?vue&type=template&id=ac0b5258&scoped=true"
import script from "./ReducedPriceFormula.vue?vue&type=script&lang=js"
export * from "./ReducedPriceFormula.vue?vue&type=script&lang=js"
import style0 from "./ReducedPriceFormula.vue?vue&type=style&index=0&id=ac0b5258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0b5258",
  null
  
)

export default component.exports